var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"new_cases_box"},[_c('HomeAroundVue')],1),_c('div',{staticClass:"plugin_content"},[_c('div',{staticClass:"box1_right_search"},[_c('PageSearch',{attrs:{"title":_vm.pageSearchTitle,"placeholder":_vm.pageSearchPlaceholder},on:{"update:value":_vm.onCheckPlugin}})],1)])])
}
var staticRenderFns = []

export { render, staticRenderFns }